/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CompanySector } from './';
import {
    CompanySectorFromJSON,
    CompanySectorFromJSONTyped,
    CompanySectorToJSON,
} from './';

/**
 * 
 * @export
 * @interface CompanyDetailsContextResponse
 */
export interface CompanyDetailsContextResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyDetailsContextResponse
     */
    sizes?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyDetailsContextResponse
     */
    departments?: Array<string>;
    /**
     * 
     * @type {Array<CompanySector>}
     * @memberof CompanyDetailsContextResponse
     */
    sectors?: Array<CompanySector>;
}

/**
 * Check if a given object implements the CompanyDetailsContextResponse interface.
 */
export function instanceOfCompanyDetailsContextResponse(value: object): value is CompanyDetailsContextResponse {
    return true;
}

export function CompanyDetailsContextResponseFromJSON(json: any): CompanyDetailsContextResponse {
    return CompanyDetailsContextResponseFromJSONTyped(json, false);
}

export function CompanyDetailsContextResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyDetailsContextResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'sizes': json['sizes'] == null ? undefined : json['sizes'],
        'departments': json['departments'] == null ? undefined : json['departments'],
        'sectors': json['sectors'] == null ? undefined : ((json['sectors'] as Array<any>).map(CompanySectorFromJSON)),
    };
}

export function CompanyDetailsContextResponseToJSON(value?: CompanyDetailsContextResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'sizes': value['sizes'],
        'departments': value['departments'],
        'sectors': value['sectors'] == null ? undefined : ((value['sectors'] as Array<any>).map((v) => CompanySectorToJSON(v))),
    };
}

